import React from "react";
import NounProAppsList from "../noun-pro-apps-list";

const ProFeatures = () => {
    return (
        <div
            style={{
                background: "#FFFFFF",
                color: "#000000",
                border: "solid 3px #f2f2f2",
                maxWidth: "350px",
                margin: "0 auto"
            }}
        >
            <h3 style={{ background: "#F2f2f2", padding: "8px" }}>
                What you get
            </h3>
            <ul className="display-flex padding-m margin-t-s margin-b-s">
                <li className="pricing-features col-lg-4 col-sm-4 col-xs-4">
                    <img
                        className="pricing-illustration"
                        src={require("../../../img/pricing/pricing_illustration_lots_of_icons@2x.png")}
                        alt="Over 1 Million Icons"
                        width="50"
                        height="50"
                    />
                    <div>
                        Over 1<br /> Million Icons
                    </div>
                </li>
                <li className="pricing-features col-lg-4 col-sm-4 col-xs-4">
                    <img
                        className="pricing-illustration"
                        src={require("../../../img/pricing/pricing_illustration_royaltyfree_licenses@2x.png")}
                        alt="Royalty-free Licenses"
                        width="50"
                        height="50"
                    />
                    <div>
                        Royalty—free
                        <br /> Licenses
                    </div>
                </li>
                <li className="pricing-features col-lg-4 col-sm-4 col-xs-4">
                    <img
                        className="pricing-illustration"
                        src={require("../../../img/pricing/pricing_illustration_change_color@2x.png")}
                        alt="Change Color"
                        width="50"
                        height="50"
                    />
                    <div>Customize Icon</div>
                </li>
            </ul>
            <h3 style={{ background: "#F2f2f2", padding: "8px" }}>
                Plus all our apps for
            </h3>
            <NounProAppsList showCaptions />
        </div>
    );
};

export default ProFeatures;
